import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["strategy", "trackerInstance"];
import { SegmentationFiltersInstanceProvider } from '../state/SegmentationFiltersInstanceContext';
import { useContext } from 'react';
import SegmentationFiltersSharedContext, { SegmentationFiltersSharedProvider } from '../state/SegmentationFiltersSharedContext';
import SegmentationFiltersUI from './SegmentationFiltersUI';
import enviro from 'enviro';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FilterEditor = _ref => {
  var _sharedContext$props;
  let {
      strategy,
      trackerInstance
    } = _ref,
    instanceProviderProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const sharedContext = useContext(SegmentationFiltersSharedContext);
  if (strategy && Object.keys(sharedContext).length > 0) {
    const errorMessage = 'Detected usage of `SegmentationFiltersSharedProvider`. Did you mean you to also pass the `strategy` prop to `FilterEditor`?';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  const filterEditorInstance = /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, Object.assign({}, instanceProviderProps, {
    useOnePanel: true,
    children: /*#__PURE__*/_jsx(SegmentationFiltersUI, {})
  }));
  if (strategy) {
    return /*#__PURE__*/_jsx(SegmentationFiltersSharedProvider, {
      strategy: strategy,
      trackerInstance: trackerInstance,
      children: filterEditorInstance
    });
  }
  const hasStrategyFromSharedContext = sharedContext === null || sharedContext === void 0 || (_sharedContext$props = sharedContext.props) === null || _sharedContext$props === void 0 ? void 0 : _sharedContext$props.strategy;
  if (!hasStrategyFromSharedContext) {
    const errorMessage = 'No detected usage of `SegmentationFiltersSharedProvider` and/or missing `strategy` prop. Please pass in a `strategy` prop to `FilterEditor` and/or wrap with `SegmentationFiltersSharedProvider`.';
    if (enviro.isProd()) {
      throw new Error(errorMessage);
    } else {
      console.error(errorMessage);
      return /*#__PURE__*/_jsxs("div", {
        children: ["Error: ", errorMessage]
      });
    }
  }
  return filterEditorInstance;
};
export default FilterEditor;